import type { AppStatus_Realworks_LimitToKenmerkenSync__KenmerkMapping__Input } from '~/graphql/types';
import type { KenmerkLookup } from '../../types';
import flattenKenmerkLookup from '../flattenKenmerkLookup';

const transformFrontendKenmerken_LimitToKenmerken = (
  kenmerkLookup: KenmerkLookup | null,
): Array<AppStatus_Realworks_LimitToKenmerkenSync__KenmerkMapping__Input> =>
  flattenKenmerkLookup(kenmerkLookup).map(({ id, tag, checked }) => ({
    realworksKenmerkId: id,
    tag,
    include: checked,
  }));

export default transformFrontendKenmerken_LimitToKenmerken;
